import * as React from 'react';

import * as I18n from 'i18n-js';
import { Filter } from './search_filters';
import OverflowingRow from './overflowing_row';
import { experiments, GUITAR_TRAIT_VALUES, MARKETPLACE_TRAIT_FILTERS, MICROPHONE_TRAIT_VALUES, INTERFACE_TRAIT_VALUES, PRO_AUDIO_TRAIT_VALUES } from '../constants';
import CoreLink from './core_link';
import { flatten } from 'lodash';
import { useUser, useExpEnabled } from '../user_hooks';
import { formatExperimentsForEventAttributes } from '../elog/mparticle';
import { MParticleEventName } from '../elog/mparticle_types';
import { withRouter, WithRouterProps } from 'react-router';

interface IExternalProps {
  filters: Filter[];
  onMarketplace?: boolean;
}

type IProps = IExternalProps & WithRouterProps;

const COMPONENT_NAME = 'SuggestedFilters';

function traitFiltersPresent(filters: Filter[]) {
  return !!traitFilters(filters)?.length;
}

function traitFilters(filters: Filter[]) {
  return filters.filter(f => f.aggregationName === 'TRAITS' && MARKETPLACE_TRAIT_FILTERS.includes(f.key));
}

function traitValues(traitFilters: Filter[], props: IProps) {

  const flattenedValues = flatten(
    traitFilters.map(filter => (
      filter.options
    )),
  );

  const filteredValues = flattenedValues.filter(f => f.count && f.count.value > 0 && !f.selected);

  if (props.location.query?.product_type === 'electric-guitars') {
    return sortedValues(filteredValues, GUITAR_TRAIT_VALUES);
  } if (props.location.query?.category === 'microphones') {
    return sortedValues(filteredValues, MICROPHONE_TRAIT_VALUES);
  } if (props.location.query?.category === 'interfaces') {
    return sortedValues(filteredValues, INTERFACE_TRAIT_VALUES);
  } if (props.location.query?.product_type === 'pro-audio') {
    return sortedValues(filteredValues, PRO_AUDIO_TRAIT_VALUES);
  }
  return filteredValues;

}

function sortedValues(filteredValues, sortedOrder) {
  const mapOrder = (order, key) => (a, b) => (order.indexOf(a[key]) > order.indexOf(b[key]) ? 1 : -1);

  return filteredValues
    .filter(f => sortedOrder.includes(f.optionValue))
    .sort(mapOrder(sortedOrder, 'optionValue'));
}

function SuggestedFilters(props: IProps) {
  const { filters, onMarketplace, location } = props;
  const user = useUser();
  const optedIn = useExpEnabled(experiments.SUGGESTED_FILTERS);

  const baseClickEvent = {
    componentName: COMPONENT_NAME,
    eventName: MParticleEventName.ClickedTraitFilter,
    experiments: formatExperimentsForEventAttributes(user, [
      experiments.MARKETPLACE_TRAIT_FILTERS,
    ]),
  };

  if (!traitFiltersPresent(filters) || !optedIn || !onMarketplace) { return null; }

  const values = traitValues(traitFilters(filters), props);

  if (!values) { return null; }

  return (
    <>
      <OverflowingRow
        condensed
        title={I18n.t('discovery.suggestedFilters')}
      >
        <div className="d-flex">
          {values.map((filter) => (
            <CoreLink
              key={filter.optionValue}
              className="grid-filter__action"
              to={
                {
                  query: {
                    ...location.query,
                    ...{ [filter.paramName]: filter.setValues },
                  },
                }
              }
              clickEvent={{
                ...baseClickEvent,
                displayStyle: filter.name,
                selected: !filter.selected,
              }}
              rel="nofollow"
            >
              {filter.name}
            </CoreLink>
          ))}
        </div>
      </OverflowingRow>
    </>
  );
}

export default withRouter(SuggestedFilters);



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/src/components/suggested_filters.tsx